// Angular
import { NgModule }      from '@angular/core';

// Afidium
import { BackButtonComponent } from './back-button.component';
import { BtnModule } from 'libraries/ui_button/btn.module';

@NgModule({
    imports: [
        BtnModule,
    ],
    declarations: [
        BackButtonComponent,
    ],
    exports: [
        BackButtonComponent,
    ],
})
export class BackButtonModule {  }